import { render, staticRenderFns } from "./EWUserLimitConfigLogShow.vue?vue&type=template&id=b8a40be0&"
import script from "./EWUserLimitConfigLogShow.vue?vue&type=script&lang=js&"
export * from "./EWUserLimitConfigLogShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports